import React, { FC } from 'react';
import useMiniCard from 'hooks/useMiniCard';
import nanoid from 'nanoid';
import { BadgesStyles } from './BadgesStyles';
import Badge from './components/Badge';

const Badges: FC = () => {
  const {
    data: { badges },
  } = useMiniCard();

  if (badges.length <= 0) return null;

  return (
    <BadgesStyles>
      {badges.map(({ text, gray }) => (
        <Badge key={nanoid()} className="truckmarket-badge" gray={!!gray}>
          {text}
        </Badge>
      ))}
    </BadgesStyles>
  );
};

export default Badges;
